import Vue from 'vue'
import Router from 'vue-router'
import Layout from "@/views/layout";
Vue.use(Router)

export const constantRoutes = [
    {
        path: '/',
        redirect: "/home",
        component: Layout,
        children: [
            {
                path: 'home',//首页
                component: () => import('@/views/helpHandbook'),
                name: "helpHandbook"
            },
            {
                path: 'home1',//首页
                component: () => import('@/views/helpHandbook/indexNew.vue'),
                name: "helpHandbook"
            },
            {
                path: 'community',//社区
                component: () => import('@/views/community'),
                name: "community"
            },
        ]
    },
    // 404 page must be placed at the end !!!
    {
        path: '*',
        redirect: '/404',
        hidden: true
    }
]

const createRouter = () => new Router({
    scrollBehavior: () => ({
        y: 0
    }),
    routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
